import React from 'react';
import { Drawer } from 'antd';
import StreamOpsPanel from './StreamOpsPanel';

/** Stand-alone drawer around StreamOpsPanel (used by Overview / Risk / Messages / Domains / API keys). */
const StreamOpsDrawer = ({ streamId, onClose, onChanged }) => (
    <Drawer open={!!streamId} onClose={onClose} width={760} title={streamId ? `发信流 #${streamId}` : ''} destroyOnClose>
        {streamId ? <StreamOpsPanel streamId={streamId} onChanged={onChanged} showStatusActions /> : null}
    </Drawer>
);

export default StreamOpsDrawer;
